import * as types from "../types/fidelidade_mapa";

const INITIAL_STATE = {
  clientes: [],
  loading: false,
  localizacao_empresa: {
    latitude: 0,
    longitude: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FIDELIDADE_MAPA_SET_CLIENTES:
      return {
        ...state,
        clientes: action.payload,
      };
    case types.FIDELIDADE_MAPA_SET_LOCALIZACAO_EMPRESA:
      return { ...state, localizacao_empresa: action.payload };
    case types.FIDELIDADE_MAPA_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};
